<template>
	<div class="anli">
		<Bannerinner/>
		<div class="titleinfo">
			<h3><a href="/">首页</a><em>></em><a href="javascript:void(0)">胜诉案例</a><em>></em>{{lmname}}</h3>
				<h2 class="linebox">
					<strong>拆迁案例</strong>
					<em></em>
					<p>依法维权&nbsp;&nbsp;&nbsp;&nbsp;冠领助力</p>
				</h2>
			</div>
			<div class="teamwrap">
				<div class="teambtn">
					<span @click="changeIndex(index,item.xid,item.zmid)" v-for="item,index in navList" :key="item.id" :class="index == currentIndex ? 'active' : ''">{{item.name}}</span>
				</div>
				<div class="teambox">
					
					<div class="teamitem" v-for="item,index in anliData" :key="item.id">
						<router-link :to="{path:'/anli/'+item.type+'/'+item.id+'.html'}">
							<div class="teamimg"><img :src="item.thumb" alt=""></div>
							<div class="teaminfo">
								<strong>{{item.title}}</strong>
								<p>{{item.description}}</p>
								<div class="teamtime">
									<span>{{item.create_time}}</span>
								</div>
							</div>
						</router-link>
					</div>

				</div>
				<div class="page">
				 <el-pagination
				   background
				   hide-on-single-page
				   :current-page.sync='currentpage'
				   @current-change="getPage"
				   layout="prev, pager, next"
				   prev-text="上一页"
				   next-text="下一页"
				   :page-size="pagesize"
				   :pager-count = pagerCount
				   :total="total">
				 </el-pagination>
				</div>
			</div>
			<div class="honorteam">
				<h3>荣誉律师</h3>
				<ul>
					<li>
						<router-link :to="{path:'/team/v/1.html'}"><img src="../assets/images/zhous.jpg" alt=""></router-link>
					</li>
					<li>
						<router-link :to="{path:'/team/v/9.html'}"><img src="../assets/images/ren.jpg" alt=""></router-link>
					</li>
					<li>
						<router-link :to="{path:'/team/v/33.html'}"><img src="../assets/images/wang.jpg" alt=""></router-link>
					</li>
					<li>
						<router-link :to="{path:'/team/v/3.html'}"><img src="../assets/images/zhang.jpg" alt=""></router-link>
					</li>
					
					</ul>
				<router-link to="/team/index.html" class="morelink">了解更多</router-link>
			</div>
			<div class="hottag">
				<h3>热门标签</h3>
				<ul>
					<li @click="toSearch(item.name)" v-for="item,index in searchKeys" :key="item.id">{{item.name}}</li>
				</ul>
			</div>
	</div>
</template>

<script>
	import $ from 'jquery'
	import {request} from '../network/request.js'
	import GLOBAL from '../global/global.js'
	import Bannerinner from "@/components/Bannerinner"
	import { title } from '../global/common.js'
	export default{
		name:'Anli',
		components:{
			Bannerinner
		},
		data(){
			return {
				anliData:[],
				total:0,
				pagesize:8,
				pagerCount:5,
				currentpage:1,
				id:40,
				currentIndex:0,
				zhixing:0,
				zrData:[],
				lmname:'国家赔偿',
				lmid:5,
				xid:0,
				zmid:0,
				navList:[
					{id:0,name:'国家赔偿',xid:5,zmid:22},
					{id:1,name:'违法拆迁',xid:6,zmid:23},
					{id:2,name:'拆违决定',xid:7,zmid:26},
					{id:3,name:'补偿决定',xid:8,zmid:25},
					{id:4,name:'征收决定',xid:9,zmid:24},
					{id:5,name:'信息公开',xid:10,zmid:27}
				],
				searchKeys:[
					{id:0,name:'房屋征收'},
					{id:1,name:'房屋征收纠纷'},
					{id:2,name:'强制拆除房屋'},
					{id:3,name:'河南拆迁律师'},
					{id:4,name:'行政协议纠纷'},
					{id:5,name:'拆迁补偿'},
					{id:6,name:'江苏拆迁维权'},
					{id:7,name:'江苏拆迁诉讼'},
					{id:8,name:'拆迁补偿安置'},
					{id:9,name:'临沂拆迁诉讼'},
					{id:10,name:'征地补偿协议'},
					{id:11,name:'农村拆迁纠纷'},
					{id:12,name:'新乡拆迁诉讼'},
					{id:13,name:'拆迁补偿诉讼'},
					{id:14,name:'拆迁补偿纠纷'},
					{id:15,name:'行政诉讼律师'}
				]
			}
		},
		methods:{
			toSearch(name){
				this.$router.push({ path:'/search/index.html',query:{'name':encodeURI(name)}})
			},
			getData(){
				let that = this
				request({
					url: '/anli/liebiao?xid='+that.xid+'&zmid='+that.zmid+'&page=1&page_size=8',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							that.anliData = []
							let beforeData = jsondata['data']
							jsondata['data'].forEach(function(value,index,arr){
								if(value['leibie'] == "xinty"){
									value['type'] = 'v'
									if(value['thumb'].length > 100){
										let beforeimg = value['thumb'].split(':')[21];
										value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
									}
								}else if(value['leibie'] == 'zmty'){
									value['type'] = 'm'
									value['thumb'] = 'http://api.guanlingls.com'+value['thumb']
								}
								value['create_time'] = value['create_time'].split(' ')[0]
								that.anliData.push(value)
								
							})
							that.total = jsondata['data'][0]['total']	//总页数
							// console.log(that.anliData)
						}
					}]
				})
			},
			getPage(val){
				let that = this
				request({
					url: '/anli/liebiao?xid='+that.xid+'&zmid='+that.zmid+'&page='+val+'&page_size=8',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							that.anliData = []
							let beforeData = jsondata['data']
							jsondata['data'].forEach(function(value,index,arr){
								if(value['leibie'] == "xinty"){
									value['type'] = 'v'
									if(value['thumb'].length > 100){
										let beforeimg = value['thumb'].split(':')[21];
										value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
									}
								}else if(value['leibie'] == 'zmty'){
									value['type'] = 'm'
									value['thumb'] = 'http://api.guanlingls.com'+value['thumb']
								}
								value['create_time'] = value['create_time'].split(' ')[0]
								that.anliData.push(value)
								
							})
							that.total = jsondata['data'][0]['total']	//总页数
							// console.log(that.anliData)
						}
					}]
				})
			},
			getlawyer(){
				let that = this
				request({
					url: '/team/read?catid=14&pgae=1&page_size=4',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							let beforeData = jsondata['data']
							beforeData['data'].forEach(function(value,index,arr){
								if(value['thumb'].length > 100){
									let beforeimg = value['thumb'].split(':')[21];
									value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
	
									that.zrData.push(value)
								}
							})
							// console.log(that.zrData)

						}
					}]
				})
			},
			changeIndex(index,xid,zmid){
				this.currentIndex = index
				this.xid = xid
				this.zmid = zmid
				this.lmname = this.navList[index].name
				this.getData()
			},
			initData(){
				let that = this
				
				document.title = '胜诉案例-'+title
				// that.getlawyer(13)
				// that.getlawyer(14)
				let xid = this.$route.query.xid
				let zmid = this.$route.query.zmid
				xid = xid == undefined ? 5 : xid
				zmid = zmid == undefined ? 22 : zmid
				this.xid = xid
				this.zmid = zmid
				this.currentIndex = (xid-5)
				
				
				// console.log(this.$route)
				
				
				
				this.getData()
				this.getlawyer()
			}
		},
		created() {
			this.initData()

		},
		watch:{
			$route(to,from){
				this.initData()
			}
		}
	}
</script>

<style lang="scss" scoped>
.teamwrap{
    background: #fff;
    padding: 0 .2rem;
    overflow: hidden;
    margin-top: .15rem;
    .teambtn{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-top: .3rem;
        span{
			margin: 0 .35rem .2rem;
            font-size: .26rem;
			height: .6rem;
			line-height: .6rem;
			text-align: center;
			width: 1.6rem;
            white-space: nowrap;
            border: 1px solid #eeeeee;
            color: #9b9494;
            transition: all .2s linear;
        }
        span.active{
            background-color: #c21a20;
            color: #fff;
        }
    }
    .teambox{
        overflow: hidden;
        border-top: 1px solid #eee;
        border-bottom: 1px solid #eee;
        padding-top: .4rem;
        margin-top: .15rem;
        .teamitem{
            margin-bottom: .4rem;
            a{
                display: flex;
                justify-content: space-between;
                .teamimg{
                    width: 2.2rem;
                    height: 1.6rem;
                    box-shadow: 0 0 2px #ccc;
                    overflow: hidden;
                    img{
                        width: 2.2rem;
                    }
                }
                .teaminfo{
                    width: 4.65rem;
                    strong{
                        display: block;
                        font-size: .28rem;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        margin-bottom: .05rem;
                    }
                    p{
                        font-size: .26rem;
                        color: rgb(163, 161, 161);
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        margin: .1rem auto .13rem;
                    }
                    .teamtime{
                        span{
                            font-size: .26rem;
                            color: rgb(163, 161, 161);
                            background: url('../assets/images/img_58.png') no-repeat left center / .3rem;
                            display: block;
                            text-indent: .4rem;
                        }
                    }
                }
            }
        }

    }
}
.honorteam{
    padding: .6rem .3rem .3rem;
    background: #fff;
    h3{
        font-size: .35rem;
        color: #c21a20;
        border-bottom: 1px solid #eee;
        margin-bottom: .2rem;
        padding-bottom: .1rem;
    }
    ul{
        display: flex;
        justify-content: space-between;
        margin-bottom: .3rem;
        li{
            width: 1.5rem;
            height: 2.14rem;
            img{
                width: 1.5rem;
                height: 2.14rem;
            }
        }
    }
}
.hottag{
    padding: .2rem .3rem .3rem;
    background: #fff;
    border-top: 1px solid #eee;
    h3{
        font-size: .35rem;
        color: #c21a20;
    }
    ul{
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
		padding-left: .08rem;
        li{
			width: 25%;
            margin-top: .15rem;
			font-size: .26rem;
        }
    }
}

</style>